import React, { FC } from 'react';
import { EmployeeDataBaseProps } from '.';
import { Todo } from '../../components/Todo';

interface Props extends EmployeeDataBaseProps {}

export const Education: FC<Props> = ({ employee }) => {
  return (
    <div>
      <Todo todo="Koulutus" noMargin />
    </div>
  );
};

export default Education;
